import { EventDispatcher } from "three";
import { userProperties } from "./Socket";
import { EMOTION_EVENTS } from "../components/engine/tour/EmotionEvents";
import { CUSTOM_TOUR_EVENTS } from "./Events";
import { tourID } from "../setScene";
import { FEATURE_NAMES } from "../components/MVC/rolesHelper";
import { trackAnalytics } from "../components/Tracking/baglessAnalytics";
export { tourID };

class SocketTour extends EventDispatcher {

  constructor({ model, socket, engineSocket }) {
    super();
    this.model = model;
    this.socket = socket;
    this.engineSocket = engineSocket;
    model.tourData = {};
    this.tourInterval;
    this.forceStopTourTimer;

    this.iAmOnThour = (id = tourID) => {
      if (!this.model.tourData[id])
        return false;
      const { users } = this.model.tourData[id];
      const me = users.filter(user => user === userProperties.socketId);
      return me.length > 0;
    }

    this.IamContributore = (id = tourID) => {
      if (!this.model.tourData[id])
        return false;
      const { contributors } = this.model.tourData[id];
      const me = contributors.filter(user => user === userProperties.socketId);
      return me.length > 0;
    }

    this.IamGuest = (id = tourID) => {
      if (!this.model.tourData[id])
        return false;
      const { guests } = this.model.tourData[id];
      const me = guests.filter(user => user === userProperties.socketId);
      return me.length > 0;
    }

    this.tourExists = (id = tourID) => {
      return !!this.model.tourData[id];
    }

    this.setTourData = (data) => {
      this.model.tourData = data;
    }

    socket.on('tour-info', (data) => {
    });

    socket.on('tour-started', (data) => {
      if (!this.model.tourData) {
        this.model.tourData = {};
      }
      this.activeTourId = data.tour.id;
      if (this.model.pendingOneToOne && this.model.guidedMode) {
        const me = this.engineSocket.getUserData();
        const tour = data.tour || {};
        const someoneElse = tour.owner && tour.owner !== me.socketId && String(tour.id) !== String(me.userId);
        if (!someoneElse) {
          this.model.markOneToOneTour(tour);
        }
      }
      this.model.tourData[data.tour.id] = data.tour;
      this.adoptMyOneToOneTour(data.tour);
      this.model.onSocketEventUpdateUI();
      this.flushPendingPodiumInvite();

      if (data.tour.configs?.limit && this.model.iAmGuide()) {
        const limit = data.tour.configs.limit;
        this.model.info('info', `You are currently using the free version. Your tour is limited to ${limit} minutes.`, { showTime: 15000 });
        this.model.info('info', 'Upgrade to unlock unlimited access and explore without time limits!', { showTime: 15000 });
        this.forceStopTourTimer = setTimeout(() => {
          this.model.info('info', 'Your tour has ended due to time limit.');
          this.model.info('info', 'Upgrade to continue exploring without time limits!');
          this.onTourEnd();
        }, Number(limit) * 60 * 1000);
      }
    });

    socket.on('join-tour', (data) => {
      if (data.tour) {
        if (!this.model.tourData) {
          this.model.tourData = {};
        }
        this.model.tourData[data.tour.id] = data.tour;
        this.model.onSocketEventUpdateUI();
      }
    });

    socket.on('tour-ended', (data) => {
      const iAmGuide = this.model.iAmGuide();
      const iamInTour = this.model.iAmInTour();
      if (!iAmGuide && iamInTour && data?.tour.id === iamInTour?.id) {
        const user = this.engineSocket.getUsersObject()[data.tour.owner_userId];
        if (data.configs?.limitReached) {
          this.model.info('info', 'Your tour has ended due to time limit.');
        } else {
          this.model.info('info', `User ${user.userName} has stopped the tour "${data.tour.name}"`);
        }
        this.model.onTourEnded();
        this.activeTourId = null;
      }
      this.model.tourData = data.tours;
      this.model.onSocketEventUpdateUI();
    });

    socket.on('tour-new-user', (data) => {
      if (!this.model.tourData) {
        this.model.tourData = {};
      }
      this.model.tourData[data.tour.id] = data.tour;
      this.model.tourNewUser();
      this.model.onSocketEventUpdateUI();
    });


    // Callback function for 'tour-joined' event
    socket.on('tour-joined', (data) => {
      this.model.tourData[data.tour.id] = data.tour;
      this.model.onSocketEventUpdateUI();
    });

    // Callback function for 'tour-left' event ->user left
    socket.on('tour-left', (data) => {
      const mySocketId = this.engineSocket.getUserData().socketId;
      const previous = this.model.tourData && this.model.tourData[data.tour.id];
      const wasInTour = !!(previous && (
        previous.owner === mySocketId ||
        (Array.isArray(previous.users) && previous.users.includes(mySocketId))
      ));
      this.model.tourData[data.tour.id] = data.tour;
      this.model.onSocketEventUpdateUI();
      const stillInTour = !!(data.tour && (
        data.tour.owner === mySocketId ||
        (Array.isArray(data.tour.users) && data.tour.users.includes(mySocketId))
      ));
      if (wasInTour && !stillInTour && previous.owner !== mySocketId) {
        this.model.onRemovedFromTour();
      }
    });
    socket.on('tour-contributore-left', (data) => {
      this.model.tourData = data.tour;
      this.model.onSocketEventUpdateUI();
    });
    socket.on('tour-data', (data) => {
      if (!data.tours) {
        return;
      }
      const sameWorld = data.worldId == null || String(this.model.config.worldId) === String(data.worldId);
      if (!sameWorld) {
        return;
      }
      if (data.eventName === 'tour-started') {
        this.model.tourData = data.tours;
        this.adoptMyOneToOneTour(data.tour || this.model.iAmGuide());
        this.model.onSocketEventUpdateUI();
        this.flushPendingPodiumInvite();
        return;
      }
      if (this.model.iAmInTour()) {
        if (data.message === "Tour removed from podium") {
          this.dropDeclinedPodiumGhosts(data.tours);
        }
        this.model.tourData = data.tours;
        this.model.onSocketEventUpdateUI();
      }
    });
    socket.on('tour-data-on-start', (data) => {
      if (String(this.model.config.worldId) !== String(data?.worldId)) {
        return;
      }
      this.model.tourData = data.tours || {};
      this.adoptMyOneToOneTour(this.model.iAmGuide());
      this.model.onSocketEventUpdateUI();
      this.flushPendingPodiumInvite();
    });
    socket.on('tour-init', (data) => {
      if (data.tours) {
        this.model.tourData = data.tours;
        this.model.onSocketEventUpdateUI();
      }
    });

    socket.on('tour-contributor-invite', (data) => {
      console.log(data, "tour-contributor-invite");
      this.model.tourContributeInvite(data);
    });
    socket.on('tour-contributor-add', (data) => {
      console.log("tour-contributor-add", data);
      this.model.tourData[data.tour.id] = data.tour;
      this.model.tourContributeAdded();
      this.model.onSocketEventUpdateUI();
    });
    socket.on('tour-contributor-removed', (data) => {
      console.log("tour-contributor-removed", data);
      this.model.tourData[data.tour.id] = data.tour;
      this.model.tourContributorRemoved();
      this.model.onSocketEventUpdateUI();
    });
    socket.on('tour-guest-add', (data) => {
      console.log("tour-guest-add", data);
      const user = this.engineSocket.getUserBySocketId(data.user);
      this.model.tourData[data.tour.id] = data.tour;
      if (user) {
        this.model.removeUserFromInvitationTourList(user.userId);
        this.model.clearPendingTourInvitation(user.userId, null, { notify: false });
      }
      this.model.onSocketEventUpdateUI();
    });
    socket.on('tour-guest-removed', (data) => {
      console.log("tour-guest-removed", data);
      this.model.tourData[data.tour.id] = data.tour;
      this.model.onSocketEventUpdateUI();
    });
    socket.on('tour-raise-hand', (data) => {
      console.log("tour-raise-hand", data);
      this.model.tourData[data.tour.id] = data.tour;
      this.model.onSocketEventUpdateUI();
    });
    socket.on('tour-raise-hand-remove', (data) => {
      console.log("tour-raise-hand-remove", data);
      this.model.tourData[data.tour.id] = data.tour;
      this.model.onSocketEventUpdateUI();
    });
    socket.on('tour-clicked', (data) => {
      if (this.model.activeOneOnOneCall) {
        return;
      }
      if (data.id === this.model.tourModeController?.tourData?.id) {
        console.log("tour-clicked", data);
        if (data.type === "profile") {
          this.model.dispatchEvent({ type: CUSTOM_TOUR_EVENTS.PROFILE_CLICK, data })
        }
        if (data.type === "closeModal") {
          this.model.dispatchEvent({ type: CUSTOM_TOUR_EVENTS.CLOSE_MODALS, data })
        }
        if (data.type === "infoElement") {
          this.model.dispatchEvent({ type: CUSTOM_TOUR_EVENTS.INFO_CLICK, data })
        }
        if (data.type === "embeddedWebpage") {
          this.model.dispatchEvent({ type: CUSTOM_TOUR_EVENTS.IFRAME_CLICK, data })
        }
        if (data.type === "imageGallery") {
          this.model.dispatchEvent({ type: CUSTOM_TOUR_EVENTS.IMAGE_GALLERY, data })
        }
        if (data.type === "customSlide") {
          this.model.dispatchEvent({ type: CUSTOM_TOUR_EVENTS.CUSTOM_SLIDE, data })
        }
        if (data.type === "closeVideo") {
          this.model.dispatchEvent({ type: CUSTOM_TOUR_EVENTS.CLOSE_VIDEO, data })
        }
        if (data.type === "videoModal") {
          this.model.dispatchEvent({ type: CUSTOM_TOUR_EVENTS.START_VIDEO, data })
        }
        if (data.type === "sceneChange") {
          this.model.dispatchEvent({ type: CUSTOM_TOUR_EVENTS.SCENE_CHANGE, data })
        }
      }
    });
    // Event: tour-update
    socket.on('tour-update', (payload) => {
      this.model.tourData[payload.tour.id] = payload.tour;
      this.model.onSocketEventUpdateUI();
    });
    this.onTourUpdate = (payload) => {
      console.log(payload);
      this.model.tourData[payload.tour.id] = payload.tour;
      this.model.onSocketEventUpdateUI();
    }
  }

  adoptMyOneToOneTour(tour) {
    if (!tour || !this.model.pendingOneToOne || !this.model.guidedMode) {
      return;
    }
    const me = this.engineSocket.getUserData();
    const someoneElse = tour.owner && tour.owner !== me.socketId && String(tour.id) !== String(me.userId);
    if (someoneElse) {
      return;
    }
    const stored = this.model.tourData?.[tour.id] || tour;
    this.model.markOneToOneTour(stored);
  }

  flushPendingPodiumInvite() {
    const pendingGuest = this.model.pendingPodiumGuest;
    const tour = this.model.iAmGuide();
    if (!pendingGuest || !tour) {
      return;
    }
    this.model.pendingPodiumGuest = null;
    this.model.inviteUserToPodium(pendingGuest);
  }

  onTourStart = (user, componentValue, streamId, visibility) => {
    this.tourName = componentValue;
    if (componentValue === "") {
      this.tourName = "Tour-Name"
    }
    // Use userId instead of tourId for new backend structure
    const oneToOne = visibility === 'oneToOne';
    this.engineSocket.getSocket().emit("tour-start", {
      users: [],
      userId: this.engineSocket.getUserData().userId, // Tour ID is now userId
      name: this.tourName,
      worldId: this.model.config.worldId,
      streamId,
      isPrivateTour: visibility !== 'public',
      oneToOne,
      allowAudience: !oneToOne,
      maxPodium: oneToOne ? 1 : undefined,
      visibility,
    });
    trackAnalytics(this.model, "User started a tour", {
      name: this.tourName,
      streamId,
      isPrivateTour: visibility !== 'public',
      oneToOne,
    });
  }

  onTourAcceptInvite = (tourId) => {
    const tour = this.model.tourData?.[tourId];
    if (this.model.refuseOneToOneJoin(tour)) {
      this.model.info('info', $trans('one-to-one-tour-closed'));
      return;
    }
    this.engineSocket.getSocket().emit("tour-joined", {
      userId: this.engineSocket.getUserData().userId, // Use userId instead of tourId
      streamId: this.model.publishStreamId,
      tourId: tourId,
    });
    trackAnalytics(this.model, "User Joined other tour", {
      streamId: this.model.publishStreamId,
    });
  }

  onEditTourData = ({ name, layoutMode } = {}) => {
    const payload = { name, layoutMode }
    const tourStarted = this.model.iAmInTour();
    if (tourStarted) {
      socket.getSocket().emit("tour-update", { tourId: tourStarted.id, worldId: this.model.config.worldId, ...payload })
    }
  }
  onTourClicked = (payload) => {
    if (this.model.activeOneOnOneCall) {
      return;
    }
    const tourStarted = this.model.iAmInTour();
    socket.getSocket().emit("tour-clicked", payload);
    trackAnalytics(this.model, "User guide clicked on tour item", {
      tour_id: tourStarted?.id,
    });
  }
  exitTour = () => {
    const tourStarted = this.model.iAmInTour();
    tourStarted && socket.getSocket().emit("tour-leave", { tourId: tourStarted.id, worldId: this.model.config.worldId })
  }
  leavePodium = () => {
    const tourStarted = this.model.iAmInTour();
    if (!tourStarted || this.model.iAmGuide()) {
      return;
    }
    const socketId = this.engineSocket.getUserData().socketId;
    const publishing = !!(
      (Array.isArray(tourStarted.podiumUsers) && tourStarted.podiumUsers.includes(socketId))
      || (Array.isArray(tourStarted.guests) && tourStarted.guests.includes(socketId))
      || (tourStarted.streams && tourStarted.streams[socketId])
      || this.model.isTourGuest
    );
    if (!publishing) {
      return;
    }
    if (!Array.isArray(tourStarted.users)) {
      tourStarted.users = [];
    }
    if (socketId && !tourStarted.users.includes(socketId)) {
      tourStarted.users.push(socketId);
    }
    socket.getSocket().emit("tour-leave-podium", { tourId: tourStarted.id, worldId: this.model.config.worldId })
    this.model.onRemovedFromPodium();
  }
  sendEmotion = (icon) => {
    const { userId, userName, userAvatarUrl } = this.engineSocket.getUserData();
    const tourStarted = this.model.iAmInTour();
    this.engineSocket._send({
      eventName: 'tour-send-emoticon',
      senderId: userId,
      userName,
      icon,
      userAvatarUrl,
      tourId: tourStarted.id,
    })
    this.model.dispatchEvent({ type: EMOTION_EVENTS.SHOW_AND_ANIMATE, data: { userName, userAvatarUrl, icon } })
    trackAnalytics(this.model, "User sent emotikon", {
      icon,
      tour_id: tourStarted?.id,
    });
  }
  sendContributoreInvite = (receiverId) => {
    const user = this.engineSocket.getOnlineUsers().filter(user => user.userId === receiverId);
    if (!user[0])
      return;
    socket.getSocket().emit(
      'tour-contributor-invite',
      {
        senderId: userProperties.userId,
        inviteeId: user[0].socketId,
      }
    )
  }

  acceptAsTourGuest = (streamId) => {
    const tourStarted = this.model.iAmInTour() || this.model.tourModeController?.tourData;
    if (!tourStarted || !tourStarted.id) {
      return;
    }
    socket.getSocket().emit("tour-guest-add", { tourId: tourStarted.id, streamId: streamId })
    trackAnalytics(this.model, "User accepted tour invitation", {
      tour_id: tourStarted.id,
    });
  }
  onStopGuestMode = (receiverId) => {
    const user = this.engineSocket._currentUserData[receiverId]
    user && socket.getSocket().emit("tour-guest-removed", { tourId: tourID, name: this.tourName, worldId: this.model.config.worldId, socketId: user.socketId })
  }
  acceptTourGuide = () => {
    socket.getSocket().emit("tour-contributor-add", { tourId: tourID, name: this.tourName, worldId: this.model.config.worldId })
  }
  onRaiseHand = () => {
    if (this.model.tourData[tourID]) {
      const raisedHandUsers = this.model.tourData[tourID].raisedHands;
      const socketId = this.engineSocket.getUserData().socketId;
      if (raisedHandUsers.includes(socketId)) {
        socket.getSocket().emit("tour-raise-hand-remove", { tourId: tourID, name: this.tourName, worldId: this.model.config.worldId })
      } else {
        socket.getSocket().emit("tour-raise-hand", { tourId: tourID, name: this.tourName, worldId: this.model.config.worldId })
      }
    }
  }
  onTourEnd = () => {
    const tourStarted = this.model.iAmInTour();
    this.forceStopTourTimer && clearTimeout(this.forceStopTourTimer);
    socket.getSocket().emit("tour-end", { worldId: this.model.config.worldId });
    trackAnalytics(this.model, "User stopped a tour", {
      tour_id: tourStarted?.id,
    });
  }
  sendGlobalTourInvite = (userId) => {
    this.engineSocket._send({
      eventName: 'sendGlobalTourinvite',
      userId,
      data: this.model.tourData[tourID]
    })
    // socket.getSocket().emit("sendGlobalTourinvite", { userId })
  }
  // Function to update the tour users in the user interface
  updateTourUsers = (users) => {
    // Update the users list in the UI with the new users data
    // ...
  }

  //  to update the tour contributors in the user interface
  updateTourContributors = (contributors) => {
    // Update the contributors list in the UI with the new contributors data
    // ...
  }

  //  to display a message to the user
  displayMessage = (message) => {
    // Display the message in the UI
    // ...
  }
  onStartTourInterval = () => {
    if (this.tourInterval) {
      return;
    }
    // this.tourInterval = setInterval(
    //   () => {
    //     // console.log("onStartTourInterval", this.model.tourData);
    //     const tourStarted = this.tourExists(tourID, this.model.tourData);
    //     if (!tourStarted) {
    //       // this.tourInterval();
    //       return
    //     }
    //     this.engineSocket._send({
    //       eventName: 'tour-check-status',
    //       tourID
    //     })
    //   }, 2000
    // )
  }
  onStopTourInterval = () => {
    if (this.tourInterval) {
      clearInterval(this.tourInterval);
      this.tourInterval = null;
    }
  }
  onStopTourNow = () => {
    this.onTourEnd();
  }
  dropDeclinedPodiumGhosts(tours) {
    const pending = this.model.pendingTourInvitations;
    if (!pending || !pending.size || !tours) {
      return;
    }
    const stillInvited = new Set();
    const onPodium = new Set();
    Object.values(tours).forEach((tour) => {
      if (!tour) {
        return;
      }
      (tour.invitedToPodium || []).forEach((id) => stillInvited.add(String(id)));
      (tour.podiumUsers || []).forEach((id) => onPodium.add(String(id)));
      Object.keys(tour.streams || {}).forEach((id) => onPodium.add(String(id)));
    });
    const online = this.engineSocket.getUsersObject() || {};
    [...pending.entries()].forEach(([userId, kind]) => {
      if (kind !== "podium") {
        return;
      }
      const user = online[userId];
      if (!user) {
        return;
      }
      const socketId = String(user.socketId);
      if (!stillInvited.has(socketId) && !onPodium.has(socketId)) {
        this.model.markPodiumInviteDeclined(userId);
        this.model.clearPendingTourInvitation(userId, "podium", { notify: false });
      }
    });
  }

  onRefuseTourInvitation = (userId, receiverId, tourId) => {
    this.engineSocket._send({
      eventName: 'removeMeFromInviteList',
      senderId: userId,
      receiverId,
      tourId,
    })
  }
  podiumRefuseInvitation = (userId, receiverId, tourId) => {
    this.engineSocket._send({
      eventName: 'removeMeFromPodiumList',
      senderId: userId,
      receiverId,
      tourId,
    })
  }
  acceptPodium = (tourId) => {
    socket.getSocket().emit("tour-accept-podium", {
      senderId: userProperties.userId,
      tourId,
    })
  }
}

export { SocketTour };
